import { createSlice } from '@reduxjs/toolkit';

// ================== Reducers ================== //

const slice = createSlice({
  name: 'nomad_insurance/purchaseInsurance/applicants',
  initialState: {
    isValid: false,
    previousApplicantsIds: []
  },
  reducers: {
    setPreviousApplicantIds: (state, { payload }) => {
      state.previousApplicantsIds = payload;
    },
    setValidity: (state, { payload }) => {
      state.isValid = payload;
    }
  }
});

export default slice.reducer;

// ================== Actions ================== //

const { actions } = slice;

export const setPreviousApplicantIds = (payload) => (dispatch) => {
  dispatch(actions.setPreviousApplicantIds(payload));
};
export const setValidity = (isValid) => (dispatch) => {
  dispatch(actions.setValidity(isValid));
};
